import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { download } from "../../pages/finance/FinanceHome";
import { Alert, Field, addDays, btn, input, iso, msg } from "./common";

const KINDS = { "labor-hours": "Labor hours by project / cost code", "crew-utilisation": "Crew utilisation", "open-pos": "Open purchase orders", "equipment-due": "Equipment due" };

export default function Reports() {
  const today = iso(new Date());
  const [kind, setKind] = useState("labor-hours");
  const [range, setRange] = useState({ start: addDays(today, -30), end: today });
  const [rep, setRep] = useState(null);
  const [err, setErr] = useState("");
  const params = { start: range.start, end: kind === "equipment-due" ? addDays(range.end, 30) : range.end };
  useEffect(() => {
    api.get(`/workforce/reports/${kind}`, { params }).then((r) => { setRep(r.data); setErr(""); }).catch((e) => { setRep(null); setErr(msg(e)); });
  }, [kind, range.start, range.end]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <section className="space-y-3" data-testid="wf-reports">
      <h2 className="font-heading text-lg">Reports</h2>
      <div className="grid gap-2 sm:grid-cols-4 items-end">
        <Field id="wf-r-kind" label="Report"><select id="wf-r-kind" className={input} value={kind} onChange={(e) => setKind(e.target.value)} data-testid="wf-r-kind">
          {Object.entries(KINDS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
        <Field id="wf-r-start" label="From"><input id="wf-r-start" type="date" className={input} value={range.start} onChange={(e) => setRange({ ...range, start: e.target.value })} data-testid="wf-r-start" /></Field>
        <Field id="wf-r-end" label="To"><input id="wf-r-end" type="date" className={input} value={range.end} onChange={(e) => setRange({ ...range, end: e.target.value })} data-testid="wf-r-end" /></Field>
        <button type="button" className={btn} onClick={() => download(`/workforce/reports/${kind}.csv?start=${params.start}&end=${params.end}`, `${kind}.csv`)} data-testid="wf-r-csv">Export CSV</button>
      </div>
      <Alert text={err} testid="wf-reports-error" />
      {rep && (rep.rows.length === 0 ? <p data-testid="wf-r-empty">Nothing in this range.</p> : (
        <div className="overflow-x-auto"><table className="min-w-full text-sm bg-white border border-erf-borderCream" data-testid="wf-r-table">
          <thead><tr>{rep.columns.map((c) => <th key={c} scope="col" className="text-left p-2 border-b">{c.replace(/_/g, " ")}</th>)}</tr></thead>
          <tbody>{rep.rows.map((r, i) => <tr key={i} data-testid={`wf-r-row-${i}`}>{rep.columns.map((c) => <td key={c} className="p-2 border-b">{r[c] === null || r[c] === undefined ? "—" : String(r[c])}</td>)}</tr>)}</tbody>
        </table></div>))}
    </section>
  );
}
